<template lang="pug">
  .contenedor-interno(v-on-clickaway="close")
    .card
      header.card-header
        p.card-header-title
          slot(name="title")
        a.card-header-icon
          span.icon
            i.fa.fa-thumbs-up
      .card-content
        slot
          small Esta operación
          strong no se puede
          small revertir
          br

      footer.card-footer
        a.card-footer-item(
          @click="$emit('do')"
        )
          slot(name="primaryAction")
        a.card-footer-item(
          @click="close"
        ) Cancelar

</template>

<script>
export default {
  name: 'confirmar_accion_overlay',
  data () {
    return {
    }
  },
  created () {
  },
  methods: {
    close () {
      this.$emit('close')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  .contenedor-interno
    display flex
    flex-direction column
    position absolute
    top -2px
    left -2px
    z-index: 999;
</style>



// WEBPACK FOOTER //
// Component_Confirmar_Accion_Positioned.vue?4e11b58a